import SharedReactTable from "components/shared/reactTable";
import { ProvideScrollPosition } from "contexts/scrollPosition";
import { rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React, { useMemo } from "react";

function PostamatAddresses(props) {
    const tableColumns = useMemo(() => {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
            },
            {
                Header: "Адрес",
                accessor: "geozone",
                id: "geozone/address",
                filterable: true,
                sortKey: "geozone/address",
                Cell: ({ value }) => value.address,
            },
            {
                Header: "",
                width: 50,
                accessor: "action",
                sortable: false,
                notExportable: true,
                Cell: ({ row }) => (
                    <div
                        className="btn btn-xs btn-outline-primary"
                        onClick={() => {
                            props.onChange({ name: "geozone", value: row.original });
                            props.back();
                        }}
                    >
                        Выбрать
                    </div>
                ),
            },
        ];
    }, []);

    return (
        <ProvideScrollPosition>
            <SharedReactTable
                {...props}
                isNotExportable
                wrapCname="flex-1"
                getList={props.getList}
                columns={tableColumns}
            />
        </ProvideScrollPosition>
    );
}

export default tableContainer(PostamatAddresses, "postamat-points");
